import {
  Middleware,
  MiddlewareAPI,
  configureStore,
  getDefaultMiddleware,
  isRejectedWithValue,
} from '@reduxjs/toolkit';

import appReducers from '@app/slices';

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    console.warn('We got a action!', action);

    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action)) {
      console.warn('We got a rejected action!');
      // toast.warn({
      //   title: 'Async error!',
      //   message:
      //     'data' in action.error
      //       ? (action.error.data as { message: string }).message
      //       : action.error.message,
      // });
    }

    return next(action);
  };

const middleware = getDefaultMiddleware({
  serializableCheck: false,
  // immutableCheck: false,
});

const store = configureStore({
  reducer: {
    ...appReducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger),
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;

export default store;
